import { FC } from 'react'
import Link from 'next/link'

import { Utils } from 'common/utils'
import { OfferSummary, Tag } from 'common/types/responses'

type OfferCardType = {
  offerInfo: OfferSummary
  titleOption?: 1 | 2
  tag?: Tag
}

const OfferCard: FC<OfferCardType> = ({ offerInfo, titleOption = 1, tag }) => {
  // Skip rendering if offerInfo is null/undefined
  if (!offerInfo) {
    return null
  }
  const backgroundStyle = offerInfo.background_gradient
    ? { backgroundImage: offerInfo.background_gradient }
    : { backgroundColor: offerInfo.background_color }

  return (
    <Link
      className='d-block a-unstyled offer-card bg-white p-10'
      href={Utils.getOfferUrl(offerInfo)}
    >
      {tag && (
        <span className='text-muted text-uppercase fs-12 text-semibold'>
          {tag.name}
        </span>
      )}

      <div className='product-container' style={backgroundStyle}>
        <img
          src={offerInfo.image?.url ?? offerInfo.brand?.logo?.url ?? ''}
          alt={offerInfo.title}
          className='offer-image'
        />
      </div>
      <div className={`title-container${titleOption} d-flex flex-column`}>
        <h5>{offerInfo.brand?.name}</h5>
        <p className='text-medium3 text-semibold color-grey5 pe-8'>
          {offerInfo.title}
        </p>
      </div>
      <div className={`description-container${titleOption}`}>
        <p className='text-small-m text-semibold mb-0'>
          {offerInfo.description}
        </p>
      </div>
    </Link>
  )
}

export default OfferCard
